export default {
  tag: "Book a Session",
  title1: "Let's Keep Your",
  title2: "Food Truck Compliant",
  subtitle: "Schedule a 1-hour on-site consultation with our project manager in Orange County",
  features: [
    { title: "1-Hour Consultation Session", desc: "No obligation — just answers and a clear path forward." },
    { title: "OC-Specific Guidance", desc: "Our experts know every city and county office in Orange County." },
    { title: "Fast Scheduling", desc: "We typically confirm appointments within 24 hours." },
    { title: "Personalized Approach", desc: "Every consultation is tailored to your specific food truck concept." },
  ],
  imageCaption1: "Ready when you are.",
  imageCaption2: "Average response time: under 24 hours",
  successTitle: "Consultation Requested!",
  successText: "We received your request and will reach out within 24 hours to confirm your appointment.",
  submitAnother: "Submit another request",
  formTitle: "Book Your Free Session",
  formSubtitle: "Fill out the form below and we'll be in touch shortly.",
  firstName: "First Name *",
  lastName: "Last Name *",
  businessName: "Business Name *",
  roleLabel: "Your Role / Position *",
  rolePlaceholder: "Select your role...",
  roleOptions: ["Owner / Founder", "Co-Owner", "Operations Manager", "Business Partner", "Investor", "Other"],
  emailLabel: "Email Address *",
  truckStatusLabel: "Truck Status",
  truckPlaceholder: "Select your current situation...",
  truckTypes: [
    "I don't have one yet",
    "Existing truck — need permits",
    "New truck build",
    "Converting a vehicle",
    "Expanding to multiple trucks",
  ],
  servicesLabel: "Services Interested In",
  servicesOptions: [
    "Permit Assistance",
    "Food Menu Development",
    "Food Handlers Certification",
    "Truck Remodel",
    "Regulatory Compliance",
    "Truck Build & Outfitting",
  ],
  preferredDate: "Preferred Date / Time",
  conceptLabel: "Tell Us About Your Concept",
  conceptPlaceholder: "Describe your food truck concept, current challenges, or any specific questions...",
  submitting: "Submitting...",
  bookSession: "Book a Session",
  noSpam: "No spam, ever. Your information is kept completely private.",
  errorTooLong: "Message must be 500 characters or less.",
  errorGeneric: "Something went wrong. Please try again.",
  errorNetwork: "Network error. Please check your connection and try again.",
};